
    export interface ICustomerDocumentManagementScope extends ng.IScope {
        customerDocumentManagementCtrl: CustomerDocumentManagementCtrl;
    }

    export class CustomerDocumentManagementCtrl {
        public static $inject = ['$scope', '$modalInstance', '$state', 'identifier', 'canUpload'];

        constructor(
            public $scope: ICustomerDocumentManagementScope,
            public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public $state: angular.ui.IStateService,
            public identifier: string,
            public canUpload: boolean) {

            $scope.customerDocumentManagementCtrl = this;
        }

        public closeModal = (): void => {
            this.$modalInstance.dismiss();
        }
    }
